import React, { Component } from 'react'
import { connect } from 'react-redux'

import * as R from 'ramda'
import Moment from 'moment'
import Numeral from 'numeral'
import { getTimezoneDate } from 'utils/date'

import DatePicker from 'material-ui/DatePicker'

import {getMonth} from 'utils/date'
import dataActions from 'actions/dataActions'
import { doc, dirtyRead } from 'selectors/common'

let select = dirtyRead(
	(state, props) => ({
		task: doc(state, props.objectID)
	})
)

export class StartDatePicker extends Component{
	render(){
		let { props } = this
		return(
				<div style={{margin: "0px", display:"inline-block", width: "50%"}}>
                    <p style={{marginTop: "10px", marginBottom: "-12px", userSelect: "none", color: "rgba(0, 0, 0, 0.298039)", fontWeight: "100", fontSize: "10px"}} >
                    Start date</p>
                    <DatePicker
                        style={{
                            color: "#000"
                        }}
                        textFieldStyle={{
                            fontSize: "16px"
                            , width: "100px"
                            , height: "36px"
                            , color: "#000"
                        }}
                        underlineStyle={{
                            borderBottom: props.task.startDate ? "0px solid" : "0px solid"
                        }}
                        inputStyle={{color: "#000"}}
                        underlineDisabledStyle={{borderBottom: "0px solid"}}
                        hintText="Select"
						formatDate= {(date)=>getTimezoneDate(date).getDate().toString() + ' ' + getMonth(getTimezoneDate(date).getMonth()).toString() + ' ' + getTimezoneDate(date).getFullYear().toString()}
                        hintStyle={{top: "8px"}}
                        style={{width: "100px", height: "35px", marginTop: "8px"}}
                        value={(props.task.startDate)?getTimezoneDate(props.task.startDate):""}
						disabled={true}
                        onChange={(evt, value)=>{
							if (props.task.qbid) return false
                            props.STAGE({
                                _id: props.objectID
                                , startDate: value.getFullYear()+'-'+(value.getMonth()+1<10 ? "0" : "")+(value.getMonth()+1)+'-'+(value.getDate()<10 ? "0" : "")+value.getDate()
                            })}
                        }
                    />
                </div>
		)
	}
}

export default connect(select, dataActions)(StartDatePicker)



// WEBPACK FOOTER //
// ./src/routes/landlord/taskForm/StartDatePicker.js